module.exports = __webpack_public_path__ + "static/media/app.39f7dd87.png";